// index.js
import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { encryptTransform } from "redux-persist-transform-encrypt";
import loginReducer from "./slices/loginSlice";
import signUpReducer from "./slices/signUpSlice";
import { loginApi } from "./services/login";
import { signUpApi } from "./services/signUp";
import  designationReducer  from "./slices/designationSlice"; // Add this line
import  departmentReducer  from "./slices/departmentSlice"; // Add this line
import  shiftReducer  from "./slices/shiftSlice"; // Add this line
import  locationReducer  from "./slices/locationSlice"; // Add this line

const reducers = combineReducers({
  login: loginReducer,
  signUp: signUpReducer,
  designation: designationReducer, // Add this line
  department: departmentReducer, // Add this line
  shift: shiftReducer, // Add this line
  location: locationReducer, // Add this line
});

const rootReducer = (state, action) => {
  if (action.type === "logout/logout") {
    state = undefined;
  }
  return reducers(state, action);
};

const persistConfig = {
  key: "root",
  storage,
  transforms: [
    encryptTransform({
      secretKey: "my-super-secret-keyForPravi@r!e$m@i%n1d4&e4@$r",
      onError: function (error) {
        console.warn(error);
      },
    }),
  ],
  whitelist: ["login"], 
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  devTools: process.env.NODE_ENV !== "production",
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(loginApi.middleware)
      .concat(signUpApi.middleware),
});

export const persistor = persistStore(store);
